import { objectHas } from './object';
import { isArray, isObject, isString } from './type';
/**
 * 判断一个对象是否为类数组
 * @param any
 * @returns {boolean}
 */
export const arrayLike = (any) => {
    if (isArray(any))
        return true;
    if (isString(any))
        return true;
    if (!isObject(any))
        return false;
    return objectHas(any, 'length');
};
/**
 * 遍历数组，返回 false 中断遍历
 * @param {Array<V>} array
 * @param {(val: V, idx: number) => (boolean | void)} iterator
 */
export const arrayEach = (array, iterator) => {
    for (let idx = 0; idx < array.length; idx++) {
        const val = array[idx];
        if (iterator(val, idx) === false)
            break;
    }
};
/**
 * 插入到目标位置之前
 * @param {AnyArray} array
 * @param {number} start
 * @param {number} to
 */
export const arrayInsertBefore = (array, start, to) => {
    if (start === to || start + 1 === to)
        return;
    const [source] = array.splice(start, 1);
    const insertIndex = to < start ? to : to - 1;
    array.splice(insertIndex, 0, source);
};
